export default __webpack_public_path__ + "static/media/waffle5.9172ad60.jpg";